import { asyncImport } from '@/utils'
const { asyncView } = asyncImport

const DefaultLayout = () =>
  import(/* webpackChunkName: "basic-layout" */ '@/layouts/DefaultLayout')

export default [
  {
    path: '/',
    component: DefaultLayout,
    children: [
      {
        path: '',
        name: 'index',
        component: asyncView('index/IndexPage')
      },
      {
        path: '/brand',
        name: 'brand',
        component: asyncView('brand/BrandPage')
      },
      {
        path: '/topfans',
        name: 'topfans',
        component: asyncView('topfans/TopFansPage')
      },
      {
        path: '/agent',
        name: 'agent',
        component: asyncView('agent/AgentPage')
      }
    ]
  },
  {
    path: '/article',
    component: DefaultLayout,
    children: [
      { path: '', redirect: '/' },
      {
        path: 'list',
        name: 'article_list',
        component: asyncView('article/list/ArticleListPage'),
        meta: { changeMeta: true }
      },
      {
        path: 'view/:id?',
        name: 'article_view',
        component: asyncView('article/view/ArticleViewPage'),
        props: r => ({ id: r.params.id || r.query.id || '' })
      }
    ]
  },
  {
    path: '/topic',
    component: DefaultLayout,
    children: [
      { path: '', redirect: '/' },
      {
        path: 'view/:id?',
        name: 'topic_view',
        component: asyncView('topic/view/TopicViewPage'),
        props: r => ({ id: r.params.id || r.query.id || '' })
      }
    ]
  },
  {
    path: '/help',
    component: DefaultLayout,
    children: [
      { path: '', redirect: '/' },
      {
        path: 'agreement',
        name: 'agreement',
        component: asyncView('help/AgreementPage')
      },
      {
        path: 'privacy',
        name: 'privacy',
        component: asyncView('help/PrivacyPage')
      }
    ]
  },
  {
    path: '/yunying/fensitoutiao',
    component: asyncView('yunying/fensitoutiao/FensitoutiaoPage')
  },
  {
    path: '*',
    redirect: '/'
  }
]
